




































import Vue from "vue";

// Routing
import { RawLocation } from "vue-router";
import router from "@/router";
import * as routes from "@/router/routes";

// Vuex
import { mapState } from "vuex";
import { RootState } from "@/store";

// Components
import VFaIcon from "@/components/VFaIcon.vue";
import StatusAndUpdatesSection from "./StatusAndUpdatesSection.vue";
import BulkUpdatesWizard from "@/views/App/ServiceAndUpdates/UpdatesManagement/BulkUpdatesWizard/index.vue";
import InstallationTreePath from "@/components/InstallationTreePath.vue";

// Model
import _ from "lodash";
import { MODULE_COLORS } from "@/utility/Constants";
import { GetInstallationsReqData } from "@/model/communication/device/GetInstallationsReqData";
import { GetInstallationsResData } from "@/model/communication/device/GetInstallationsResData";
import { GetInstallationsCommand } from "@/model/communication/device/GetInstallationsCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { FetchInstallationsStatusResponse } from "@/model/communication/status/FetchInstallationsStatusResponse";
import { FetchInstallationsStatusCommand, GetDevicesStatusReqData } from "@/model/communication/status/FetchInstallationsStatusCommand";
import { FetchInstallationUpdatesStatusResponse } from "@/model/communication/updatesStatus/FetchInstallationUpdatesStatusResponse";
import {
    FetchInstallationsUpdatesStatusRequestData,
    GetServerFetchInstallationsUpdatesStatusReqData,
} from "@/model/communication/updatesStatus/FetchInstallationsUpdatesStatusRequestData";
import { FetchInstallationUpdatesStatusCommand } from "@/model/communication/updatesStatus/FetchInstallationUpdatesStatusCommand";
import { GetInstallationBranchHistoryCommand } from "@/model/communication/branch/GetInstallationBranchHistoryCommand";
import { ClientUser } from "@/model/data/authentication/ClientUser";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default Vue.extend({
    components: {
        VFaIcon,
        StatusAndUpdatesSection,
        BulkUpdatesWizard,
        InstallationTreePath,
    },
    data() {
        return {
            MODULE_COLORS,
            installationName: "",
            installation: null,
            installationStatus: null,
            installationUpdate: null,
            installationBranchMovingList: [],
            windowHeight: window.innerHeight,
            showSettingsDialog: false,
        };
    },
    computed: {
        ...mapState({
            authUser: (state: RootState) => state.authMod.currentUser,
        }),

        isOperationsBtnNotAvailable() {
            // se non ho nessuno dei seguenti privilegi allora disabilito il button delle operazioni
            if ((this.authUser as ClientUser).profile.privileges.and(ClientPrivileges.UpdatesManagement) == ClientPrivileges.UpdatesManagement) return false;
            if ((this.authUser as ClientUser).profile.privileges.and(ClientPrivileges.PackagesManagement) == ClientPrivileges.PackagesManagement) return false;
            if ((this.authUser as ClientUser).profile.privileges.and(ClientPrivileges.DevicesManagement) == ClientPrivileges.DevicesManagement) return false;
            if ((this.authUser as ClientUser).profile.privileges.and(ClientPrivileges.DownloadLogs) == ClientPrivileges.DownloadLogs) return false;
            return true;
        },
    },
    watch: {
        installationName() {
            this.reload();
            this.getInstallationBranchMovingList();
        },

        $route() {
            this.installationName = this.$route.params.installationName;
        },
    },
    methods: {
        reload() {
            this.getInstallationInfo();
            this.getInstallationStatus();
            this.getInstallationUpdate();
        },

        async getInstallationInfo() {
            try {
                let installationNames = [];
                installationNames.push(this.installationName);
                let res: GetInstallationsResData = await new GetInstallationsCommand(new GetInstallationsReqData(installationNames)).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    if (Array.isArray(res.installations) && res.installations.length > 0) this.installation = res.installations[0];
                    else {
                        let location: RawLocation = {
                            path: routes.Root,
                        };
                        router.replace(location);
                    }
                }
            } catch (error) {
                console.error("Error in get installations: ", error);
            }
        },

        async getInstallationStatus() {
            try {
                let req: GetDevicesStatusReqData = new GetDevicesStatusReqData();
                req.installationNames = [];
                req.installationNames.push(this.installationName);
                let response: FetchInstallationsStatusResponse = await new FetchInstallationsStatusCommand(req).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installationStatus = response.installationsList[0];
                }
            } catch (e) {
                console.error("Something went wrong sending getInstallationStatus request ", e);
            }
        },

        async getInstallationUpdate() {
            try {
                let req: FetchInstallationsUpdatesStatusRequestData = new FetchInstallationsUpdatesStatusRequestData();
                req.installationNames = [];
                req.installationNames.push(this.installationName);
                let reqToServer = GetServerFetchInstallationsUpdatesStatusReqData(req);
                let response: FetchInstallationUpdatesStatusResponse = await new FetchInstallationUpdatesStatusCommand(reqToServer).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installationUpdate = response.installationsList[0];
                }
            } catch (e) {
                console.error("Something went wrong sending getInstallationUpdate request ", e);
            }
        },

        async getInstallationBranchMovingList() {
            try {
                this.installationBranchMovingList = [];
                let res = await new GetInstallationBranchHistoryCommand(this.installationName).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installationBranchMovingList = _.orderBy(res.installationBranchMovingList, ["movingDateTime"], ["desc"]);
                } else console.error("Error executing getInstallationBranchMovingList");
            } catch (e) {
                console.error("Something went wrong sending getInstallationBranchMovingList request ", e);
            }
        },
    },
    mounted() {
        this.installationName = this.$route.params.installationName;
    },
});
